import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Divider, FormHelperText, FormLabel, Grid, Stack, Tab, Tabs } from "@mui/material";
import moment from "moment";
import { connect, useDispatch } from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, Container } from "reactstrap";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import Label from "../../components/Common/Label";
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import CheckBoxGroup from "../../components/Form/CheckBoxGroup";
import CustomButton from "../../components/Form/CustomButton";
import CustomSelect from "../../components/Form/CustomSelect";
import CustomSelectMultiple from "../../components/Form/CustomSelectMultiple";
import CustomTextField from "../../components/Form/CustomTextField";
import CustomizedDatePicker from "../../components/Form/DatePicker";
import RadioButtonGroup from "../../components/Form/RadioButtonGroup";
import Helpers from "../../helpers/helpers";
import { createProduct, getGeneral, getProductDetails, resetProductState, updateProduct } from "../../store/actions";
import FormEditors from "../Forms/FormEditors";
import "../Orders/order.css";
import Accessories from "./Accessories/Accessories";
import UploadProductImagesNew from "./General/UploadProductImagesNew";
import Gift from "./Gift/Gift";
import Pricing from "./Pricing/Pricing";
import ConfigProductSpec from "./ProductSpec Configurable/ConfigProductSpec";
import ProductSpec from "./ProductSpec/ProductSpec";
import SEO from "./SEO/SEO";
import ApproveModal from "./Services/ApproveModal";
import RejectModal from "./Services/RejectModal";
import Services from "./Services/Services";
import Shipping from "./Shipping/Shipping";
import Attachments from "./Attachments/Attachments";

const AddSimpleProduct = ({ type, title, productDetails, categoryListing, contractsListing, modelListing, preAddData, productListingForGift, configurationDetails, errors, addProduct, editProduct, manufactureListing, products, userPermission, productMessage, is_student_portal }) => {
  const { ID } = useParams()
  // const [addType, setAddType ]= useState(preAddData?.addType)
  const { addType } = useParams()
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const fileInputRef = useRef();
  const [categoryForTab, setCategoryForTab] = useState([])
  const [allowMultipleSelect, setAllowMultipleSelect] = useState([])
  const [rejectModal, setRejectMOdal] = useState(false)
  const [approveModal, setApproveMOdal] = useState(false)
  const [isDifferentPrice, setIsDifferentPrice] = useState(false)
  const [filteredProductList, setfilteredProductList] = useState("")
  const [platformData, setPlatformData] = useState([
    { name: "is_ariba_product", label: "Ariba Punchout E-commerce Platform", state: false },
    { name: "is_aspeed_product", label: "Aspeed E-commerce Platform", state: false },
  ])
  const [approveable, setApproveable] = useState(false);
  const [editable, setEditable] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    if (userPermission?.length > 0) {
      userPermission?.includes("approve-product") && setApproveable(true);
      userPermission?.includes("edit-product") && setEditable(true);
      !userPermission?.includes("view-product") && navigate('/not-authorized');
    }
  }, [userPermission])

  useEffect(() => {
    dispatch(getGeneral())
  }, [])

  useEffect(() => {
    if (products) {
      let temp = products && products?.length > 0 && products?.filter((x, idx) =>
        x?.product_type !== "configurable" && x?.creation_status === "approved"
      )
      setfilteredProductList(temp)
    }
  }, [products])

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth); // Update state when window resizes
    };
    window.addEventListener("resize", handleResize);

    return (() => {
      window.removeEventListener("resize", handleResize); // Cleanup on unmount
    })
  }, [])

  useEffect(() => {
    if (productMessage?.code === "invalid_product" || productMessage?.code === "error" || productMessage?.code === "failed") {
      setNotification({
        open: true,
        msg: "Product Not Found. Redirecting to Product Listing Page...",
        type: "error",
      })
      setTimeout(() => {
        navigate("/product-listing")
        setIsLoading(false)
      }, [2000]);

    } else if (productMessage?.code === "success") {
      setIsLoading(false)
    }

  }, [productMessage]);

  useEffect(() => {
    if (preAddData) {
      setFormValues((prevValues) => ({
        ...prevValues,
        model_id: preAddData?.model_id,
        manufacturer_id: preAddData?.manufacturer_id,
        product_categories: preAddData?.categories,
      }))
      // setAddType(preAddData?.addType)
      setCategoryForTab(preAddData?.categories)
    }
  }, [preAddData])

  useEffect(() => {
    if (addProduct?.code === "success") {
      setIsLoading(false)
      setNotification({
        open: true,
        msg: "Added Successfully",
        type: "success",
      })
      dispatch(getGeneral());
      navigate("/product-listing")
    } else if (addProduct?.code === "error") {
      setNotification({
        open: true,
        msg: "Error",
        type: "error",
      })
      setIsLoading(false)
    }
  }, [addProduct])

  useEffect(() => {
    if (editProduct?.code === "success") {
      setIsLoading(false)
      setNotification({
        open: true,
        msg: "Update Successfully",
        type: "success",
      })
      setApproveMOdal(false)
      setRejectMOdal(false)
      dispatch(getProductDetails({ id: ID }))
      dispatch(resetProductState())
      dispatch(getGeneral());
    } else if (editProduct?.code === "error") {
      setNotification({
        open: true,
        msg: "Error",
        type: "error",
      })
    }
  }, [editProduct])

  useEffect(() => {
    if (errors?.[0]) {
      setNotification({
        open: true,
        msg: "Some fields are incomplete or invalid !",
        type: "warning",
      })
    }
    setIsLoading(false);
  }, [errors])

  useEffect(() => {
    if (type === "Edit") {
      setIsLoading(true)
      if (ID) {
        dispatch(getProductDetails({ id: ID }))
        setIsLoading(true)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ID]);

  const defaultValues = {
    title: "",
    slug: "",
    status: "",
    sku: "",
    product_type: addType,
    creation_status: "pending_approval",
    reject_reason: "",
    quantity: "",
    notify_for_quantity_below: "",
    set_product_as_new_from: "",
    set_product_as_new_to: "",
    product_images_details: [],
    product_overview: "",
    product_descriptions: "",
    ariba_price: "",
    aspeed_price: "",
    is_ariba_product: 0,
    is_aspeed_product: 0,
    product_discounts: [],
    product_services: [],
    config_services: [],
    // shipping
    weight_in_gram: "",
    length_in_mm: "",
    width_in_mm: "",
    height_in_mm: "",
    // seo
    product_meta_title: "",
    product_meta_description: "",
    //settings
    platform_availability: {
      "Ariba Punchout E-commerce Platform": false,
      "Aspeed E-commerce Platform": true,
    },
    visibility: "",
    manufacturer_id: "",
    product_upsells: [],
    gift: [{}],
    model_id: "",
    product_categories: [],
    product_price_groups: [
      {
        customer_group_id: 1,
        price: ""
      },
      {
        customer_group_id: 2,
        price: ""
      }
    ],
    variants: [],
  }

  useEffect(() => {
    if (productDetails?.product_type === "variant") {
      setTabData([
        { id: 0, name: "About" },
      ])
    } else if (addType === "simple") {
      setTabData([
        { id: 0, name: "About" },
        { id: 1, name: "Pricing" },
        { id: 2, name: "Product Specs" },
        { id: 8, name: "Attachments" },
        { id: 4, name: "Gifts" },
        { id: 5, name: "Accessories" },
        { id: 6, name: "Shipping" },
        { id: 7, name: "SEO" },
      ])
    } else {
      setTabData([
        { id: 0, name: "About" },
        { id: 1, name: "Pricing" },
        { id: 2, name: "Product Specs" },
        { id: 3, name: "Services" },
        { id: 8, name: "Attachments" },
        { id: 4, name: "Gifts" },
        { id: 5, name: "Accessories" },
        { id: 6, name: "Shipping" },
        { id: 7, name: "SEO" },
      ])
    }
  }, [addType, productDetails]);

  useEffect(() => {
    if (type === "Edit") {
      if (ID) {
        const filtered = productDetails || []
        if (filtered) {
          setFormValues({
            name: filtered?.product_name,
            slug: filtered?.slug,
            product_type: filtered?.product_type,
            product_descriptions: filtered?.product_descriptions,
            quantity: filtered?.quantity,
            notify_for_quantity_below: filtered?.notify_for_quantity_below,
            quantity_turn_out_of_stock: filtered?.quantity_turn_out_of_stock,
            sku: filtered?.sku,

            //settings
            is_ariba_product: filtered?.is_ariba_product,
            is_aspeed_product: filtered?.is_aspeed_product,
            visibility: filtered?.visibility,
            status: filtered.status,
            contracts: filtered?.contracts?.map((x, idx) => parseInt(x?.school_contract_id)),

            set_product_as_new_from: filtered?.set_product_as_new_from,
            set_product_as_new_to: filtered?.set_product_as_new_to,
            product_images_details: filtered?.product_images_details,
            product_overview: filtered?.product_overview,

            ariba_price: Number(filtered?.ariba_price),
            aspeed_price: Number(filtered?.aspeed_price),
            product_discounts: filtered?.discounts,
            product_services: filtered?.service_options,
            config_services: filtered?.config_services,
            // shipping
            weight_in_gram: filtered?.weight_in_gram,
            length_in_mm: filtered?.length_in_mm,
            width_in_mm: filtered?.width_in_mm,
            height_in_mm: filtered?.height_in_mm,
            lead_time: filtered?.lead_time,
            // seo
            product_meta_title: filtered?.product_meta_title,
            product_meta_description: filtered?.product_meta_description,
            product_meta_keyword: filtered?.product_meta_keyword,
            product_upsells: filtered?.upsells,
            product_gifts: filtered?.product_gifts,
            // specification 
            manufacturer_id: filtered?.manufacturer_id,
            model_id: filtered?.model_id,
            //pricing
            product_price_groups: filtered?.price_groups,
            variants: filtered?.variants,
            creation_status: filtered?.creation_status,

            //attachments
            pdf_id: filtered?.attachment?.id || "",
            pdf: filtered?.attachment?.path || "",
            pdf_name: filtered?.attachment?.label || "",
          })
          let tempCategory = []
          filtered?.product_categories?.map((x, idx) =>
            tempCategory.push(x.id))

          setFormValues((prevValues) => ({
            ...prevValues,
            product_categories: tempCategory,
          }))

          setCategoryForTab(tempCategory)
          if (filtered?.price_groups?.length > 1) {
            if (filtered?.price_groups?.[0]?.price !== filtered?.price_groups?.[1]?.price) {
              setIsDifferentPrice(true)
            } else {
              setIsDifferentPrice(false)
            }
          } else {
            setIsDifferentPrice(false)

          }

          //image
          setProfileImg(filtered?.thumbnail)

          setPlatformData([
            { name: "is_ariba_product", label: "Ariba Punchout E-commerce Platform", state: filtered?.is_ariba_product === 1 ? true : false },
            { name: "is_aspeed_product", label: "Aspeed E-commerce Platform", state: filtered?.is_aspeed_product === 1 ? true : false },
          ])
        }
      }
    }
  }, [productDetails]);
  const [loading, setIsLoading] = useState(false);
  const [values, setFormValues] = useState(defaultValues);
  const [profileImg, setProfileImg] = useState();
  const [tabData, setTabData] = useState([]);
  const [notification, setNotification] = useState({
    open: false,
    msg: "",
    type: "success",
  });

  const [tabValue, setTabValue] = useState(0); // Active tab
  const [isScrolling, setIsScrolling] = useState(false); // Prevents conflicts during smooth scroll
  const observer = useRef(null);

  const handleChangeTab = (id) => {
    setIsScrolling(true); // Prevent `IntersectionObserver` from updating during manual scroll
    setTabValue(id);
    const element = document.getElementById(id);
    if (id === 7) {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: "smooth"
      });
    }
    else if (element) {
      const offset = height > 600 ? 300 : 200; // Adjust scroll offset
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY;
      const adjustedPosition = elementPosition - offset;

      window.scrollTo({ top: adjustedPosition, behavior: "smooth" });

      // Reset scrolling flag after scroll finishes
      setTimeout(() => setIsScrolling(false), 600); // Adjust delay based on scroll duration
    }
  };
  useEffect(() => {
    const handleIntersect = (entries) => {
      if (isScrolling) return; // Avoid updating during smooth scroll

      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const id = parseInt(entry.target.id);
          setTabValue(id); // Update the active tab based on section in view
        }
      });
    };

    // 1️⃣ Observer for the first section (50% visible)
    const firstObserver = new IntersectionObserver(handleIntersect, {
      root: null,
      threshold: 0.2, // Trigger when section is 50% visible
    });

    // 2️⃣ Observer for the rest of the sections (100% visible)
    const otherObserver = new IntersectionObserver(handleIntersect, {
      root: null,
      threshold: height > 600 ? 1 : 0.8, // Trigger when section is fully visible (100%)
    });

    // Get all target divs
    const divs = document.querySelectorAll(".observe-div");

    // Observe the first section with the firstObserver (50% visible)
    const firstSection = divs[0];
    if (firstSection) firstObserver.observe(firstSection);

    // Observe other sections with the otherObserver (100% visible)
    const otherSections = Array.from(divs).slice(1);
    otherSections.forEach((section) => otherObserver.observe(section));

    // Cleanup on component unmount
    return () => {
      if (firstObserver) firstObserver.disconnect();
      if (otherObserver) otherObserver.disconnect();
    };
  }, [isScrolling]);


  const onChangeFile = (file) => {
    if (Helpers.isFileSizeValid(file)) {
      Helpers.getPreviewBase64(file, (result) => {
        setProfileImg(result);
      });
    }
    // Clear the upload file value
    fileInputRef.current.value = '';
  };

  const data = [
    { label: "Published", value: "1" },
    { label: "Unpublished", value: "0" },
  ]

  const visibilityData = [
    { label: "Not Visibile", value: "0" },
    { label: "Catalog, Search", value: "1" },
  ]

  const error = errors?.[0];

  const getImage = async () => {
    let tempImage = [];

    const convertImage = (img, is_thumbnail) => {
      return new Promise((resolve) => {
        Helpers.imageToBase64Sync(img, (base64) => {
          tempImage.push({ image: base64, is_thumbnail });
          resolve();
        });
      });
    };

    let tasks = [];

    if (profileImg) {
      tasks.push(convertImage(profileImg, 1)); // Convert and store promise
    }

    if (values?.product_images_details?.length > 0) {
      values.product_images_details.forEach((x) => {
        tasks.push(convertImage(x?.image, 0)); // Convert and store each promise
      });
    }

    await Promise.all(tasks); // Wait for all images to be converted
    return tempImage; // Return final processed images
  };


  const useWindowSize = () => {
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
      const handleResize = () => setWidth(window.innerWidth);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    return width;
  };


  const useWindowSizeHeight = () => {
    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
      const handleResize = () => setHeight(window.innerHeight);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    return height;
  };

  const width = useWindowSize();
  const height = useWindowSizeHeight();
  const getDiscountStatus = (x) => {
    let status = ""
    if (x?.is_ariba_discount == 0 && x?.is_aspeed_discount == 0) {
      status = 0
    } else if (x?.is_ariba_discount == 1 && x?.is_aspeed_discount == 1) {
      status = 1
    } else if (x?.is_ariba_discount == 1 && x?.is_aspeed_discount == 0) {
      status = 3
    } else if (x?.is_ariba_discount == 0 && x?.is_aspeed_discount == 1) {
      status = 2
    }
    return status
  }
  const handleSubmit = async (type, creation_status_type, isApprove = false) => {
    setIsLoading(true)
    let images = await getImage(); // Wait for images to be converted

    //check duplicate upsell
    const categoryIds = values?.product_upsells?.map(x => x.category_id);
    const hasDuplicate = categoryIds.length !== new Set(categoryIds).size;
    //cehck duplicate services
    const servicesIdS = values?.product_services?.map(x => x.service_type_id);

    if (hasDuplicate) {
      setNotification({
        open: true,
        msg: "Duplicated product upsell category, please check!",
        type: "error",
      })
      setIsLoading(false)
      return; // Stop process
    }

    // Check for duplicate default_option: 1 within the same service_id
    const serviceGroups = values?.product_services?.reduce((groups, service) => {
      if (!groups[service.service_id]) {
        groups[service.service_id] = [];
      }
      groups[service.service_id].push(service);
      return groups;
    }, {});

    const hasInvalidDefaultOptions = Object.values(serviceGroups).some(group => {
      const defaultOptions = group.filter(service => service.default_option === 1);
      return defaultOptions.length > 1; // Ensure only one default_option per service_id
    });

    if (hasInvalidDefaultOptions) {
      setNotification({
        open: true,
        msg: "Each service can only have one default option!",
        type: "error",
      });
      setIsLoading(false);
      return; // Stop process
    }

    let attachTemp = values?.pdf_id ?
      {
        id: values?.pdf_id, // no update the attachment
        label: values?.pdf_name,
        file: values?.pdf,
      } :
      {
        //update the attachment
        label: values?.pdf_name,
        file: values?.pdf,
      }

    let data = {
      name: values?.name,
      slug: values?.slug,
      status: values?.status,
      sku: values?.sku,
      product_type: addType,
      is_ariba_product: values?.is_ariba_product,
      is_aspeed_product: values?.is_aspeed_product,
      quantity: values?.quantity,
      notify_for_quantity_below: values?.notify_for_quantity_below,
      quantity_turn_out_of_stock: values?.quantity_turn_out_of_stock,
      set_product_as_new_from: values?.set_product_as_new_from,
      set_product_as_new_to: values?.set_product_as_new_to,
      overview: values?.product_overview,
      descriptions: values?.product_descriptions,
      ariba_price: values?.is_ariba_product === 0 ? values?.ariba_price || 0 : values?.ariba_price,
      contracts: values?.contracts,
      lead_time: values?.lead_time,
      // aspeed_price: values?.aspeed_price,
      product_images_details: images,
      attachment: attachTemp,
      product_discounts: values?.product_discounts?.map((x, idx) => (
        {
          discount_status: getDiscountStatus(x),
          discount_type: x?.discount_type,
          discount_value: x?.discount_value,
          discount_start: moment(x?.discount_start).format("YYYY-MM-DD 00:00:00"),
          discount_end: moment(x?.discount_end).format("YYYY-MM-DD 23:59:59"),
          min_purchase_qty: x?.min_purchase_qty,
          max_purchase_qty: x?.max_purchase_qty,
          is_ariba_discount: x?.is_ariba_discount ? 1 : 0,
          is_aspeed_discount: x?.is_aspeed_discount ? 1 : 0,
        })),
      product_services: values?.product_services?.map((x, idx) => (
        {
          service_id: x?.service_id,
          service_type_id: x?.service_type_id,
          sku: x?.sku,
          year: parseInt(x?.years),
          price: parseInt(x?.price),
          default_option: x?.default_option,
          options: x?.options?.map((y, idx) => (
            {
              year: parseInt(y?.years),
              price: parseInt(y?.price),
              default_option: y?.default_option,
              sku: y?.sku,
              service_type_id: y?.service_type_id,
            }
          ))
        }
      )),
      weight_in_gram: values?.weight_in_gram,
      length_in_mm: values?.length_in_mm,
      width_in_mm: values?.width_in_mm,
      height_in_mm: values?.height_in_mm,
      meta_title: values?.product_meta_title,
      meta_keyword: values?.product_meta_keyword,
      meta_description: values?.product_meta_description,
      visibility: values?.visibility,
      manufacturer_id: values?.manufacturer_id,
      product_upsells: values?.product_upsells?.map((x, idx) => (
        {
          category_id: x?.category_id,
          min_purchase_qty: 0, /*x?.min_purchase_qty*/
          max_purchase_qty: 1, /*x?.max_purchase_qty*/
          items: x?.items?.map((y, idx) =>
          (
            {
              upsell_product_id: y?.upsell_product_id,
              min_purchase_qty: 0, /*y?.min_purchase_qty*/
              max_purchase_qty: 1, /*y?.max_purchase_qty*/
              discount_value: y?.discount_value,
              is_percentage: y?.is_percentage,
              sort_order: y?.sort_order || 0,
              additional_info: y?.additional_info || "",
            }
          )
          )
        })),
      product_gifts: values.product_gifts?.map(({ gift_id }) => ({ gift_id })),
      model_id: values?.model_id,
      product_categories: values?.product_categories,
      product_price_groups: values?.product_price_groups,
      variants: getproductVariantProperties(),
      creation_status: creation_status_type,
    }
    let isValid = true
    if (values?.product_type === "configurable" && values?.variants) {
      const configMap = new Map();

      for (const item of values?.variants) {
        if (item.is_default === 1) {
          configMap?.set(item.configuration_id, (configMap?.get(item.configuration_id) || 0) + 1);
        }
      }

      // Check if any configuration_id has more than one `is_default: 1`
      isValid = [...configMap?.values()].every(count => count <= 1);
    }

    if (!isApprove) {
      delete data?.creation_status;
    }

    if (isValid) {
      if (type === "Add") {
        setIsLoading(true)
        dispatch(createProduct({ product: data }))
      }
      else {
        setIsLoading(true)
        dispatch(updateProduct({ id: ID, product: data }))

      }
    }
    else {
      setIsLoading(false)
      setNotification({
        open: true,
        msg: "Please make sure every product spec only have one default value!",
        type: "error",
      })
    }
  }

  const getproductVariantProperties = () => {
    let tempProperties = []
    if (addType === "simple") {
      if (values?.variants?.length > 0) {
        values?.variants && values?.variants?.length > 0 && values?.variants?.map((x, idx) =>
          x?.configuration_item_id && x?.display_name &&
          tempProperties.push({
            id: x?.id || null,
            configuration_id: x?.configuration_id,
            configuration_item_id: x?.configuration_item_id,
            display_name: x?.display_name,
            additional_info: x?.additional_info,
            sku: x?.sku,
            group_name: x?.group_name, // newly added group name
            sort_order: x?.sort_order || 0, // newly added sort order
          })
        )
      }
      return tempProperties
    } else {
      if (values?.variants?.length > 0) {
        values?.variants && values?.variants?.length > 0 && values?.variants?.map((x, idx) =>
          tempProperties.push({
            id: x?.id || null,
            configuration_id: x?.configuration_id,
            configuration_item_id: x?.configuration_item_id,
            display_name: x?.display_name,
            additional_info: x?.additional_info,
            is_default: x?.is_default || 0,
            sku: x?.sku,
            quantity: (x?.quantity === null || x?.quantity === undefined) ? 0 : x?.quantity,
            add_price: x?.add_price || 0,
            deduct_quantity: x?.deduct_quantity || 0,
            product_id: x?.product_id,
            purchase_limit: allowMultipleSelect?.find((y, idx) => y === x?.configuration_id) ? x?.purchase_limit : null,
            sort_order: x?.sort_order || 0, // newly added sort order
            group_name: x?.group_name, // newly added group name

          })
        )
      }
      return tempProperties
    }
  }

  const extractNumber = (input) => {
    if (!input || typeof input !== "string") {
      return null; // Handle undefined, null, or non-string inputs
    }

    const match = input.match(/\d+/); // Match one or more digits
    return match ? parseInt(match[0], 10) : null; // Return the number or null if no match
  };

  const handleRemoveThumbnail = () => {
    setProfileImg()
  }

  const handleCatChange = (newItem) => {

    setCategoryForTab(newItem);
  };

  const renderGeneralTab = () => {
    return (
      <Grid container spacing={2}>

        <Grid item sm={12} lg={8}>
          <Card className="p-3 px-2">
            <CardBody>
              <div className="setting-header">ABOUT</div>
              <Divider className="my-2 mb-4" />
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <CustomTextField
                    title={'Title'}
                    values={values?.name}
                    error={error && error?.name}
                    onChange={(e) => setFormValues((prevValues) => ({
                      ...prevValues,
                      name: e
                    }))}
                    placeholder="Give this product a name"
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomTextField
                    title={'URL slug'}
                    values={values?.slug}
                    error={error && error?.slug}
                    onChange={(e) => setFormValues((prevValues) => ({
                      ...prevValues,
                      slug: e
                    }))}
                    placeholder="url-slug"
                  />
                  <FormHelperText sx={{ color: "#737373" }}>The last part of the URL. If left blanks, the title of your product will be used.</FormHelperText>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <CustomTextField
                    title={'SKU'}
                    values={values?.sku}
                    error={error && error.sku}
                    onChange={(e) => setFormValues((prevValues) => ({
                      ...prevValues,
                      sku: e
                    }))}
                    placeholder="THINKPAD-I7-G5-1234"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <CustomTextField
                    title={'Quantity'}
                    values={values?.quantity}
                    error={error && error.quantity?.[0] === "The quantity must be greater than notify_for_quantity_below." ? "The quantity must greater than low stock threshold." : error?.quantity}
                    onChange={(e) => setFormValues((prevValues) => ({
                      ...prevValues,
                      quantity: e
                    }))}
                    type="number"
                    placeholder="0"
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <CustomTextField
                    title={'Out of Stock Quantity'}
                    values={values?.quantity_turn_out_of_stock}
                    error={error && error.quantity_turn_out_of_stock}
                    onChange={(e) => setFormValues((prevValues) => ({
                      ...prevValues,
                      quantity_turn_out_of_stock: e
                    }))}
                    type="number"
                    placeholder="0"
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <CustomTextField
                    title={'Low Stock Threshold'}
                    values={values?.notify_for_quantity_below}
                    error={error && error.notify_for_quantity_below}
                    onChange={(e) => setFormValues((prevValues) => ({
                      ...prevValues,
                      notify_for_quantity_below: e
                    }))}
                    placeholder="0"
                    type="number"
                  />
                </Grid>
                {productDetails?.product_type !== "variant" && <Grid item xs={12} sm={6}>
                  <CustomizedDatePicker
                    title={'Set product as new from'}
                    values={values?.set_product_as_new_from && new Date(values.set_product_as_new_from)}
                    setFormValues={setFormValues}
                    name={'set_product_as_new_from'}
                  />
                  {error && <FormHelperText sx={{ color: "red" }}>{error.set_product_as_new_from || ""}</FormHelperText>}
                </Grid>}
                {productDetails?.product_type !== "variant" && <Grid item xs={12} sm={6}>
                  <CustomizedDatePicker
                    title={'Set product as new to'}
                    values={values?.set_product_as_new_to && new Date(values.set_product_as_new_to)}
                    setFormValues={setFormValues}
                    name={'set_product_as_new_to'}
                  />
                  {error && <FormHelperText sx={{ color: "red" }}>{error.set_product_as_new_to || ""}</FormHelperText>}
                </Grid>}
                <Grid item xs={12}>Thumbnail Image ({profileImg ? '1' : '0'}/1)</Grid>
                <Grid item xs={12} display={'flex'}>
                  {
                    profileImg ?
                      <img src={profileImg && `${profileImg}`} alt="thumbnail" style={{ height: 72, width: 72, objectFit: "contain" }} /> :
                      <div className="empty-image-container"><i className="ri-image-2-fill" style={{ color: '#D0D0D0', fontSize: 40 }} /></div>
                  }
                  <div className="mb-2 mx-3 ">
                    <CustomButton
                      title={'Choose'}
                      press={() => document.getElementById("new-upload-file").click()}
                      backgroundColor={'#F2F2F2'}
                      textColor={'#101010'}
                      borderStyle={'1px solid #E3E8EE'}
                    />

                    {
                      profileImg &&
                      <span className="px-0 px-sm-3">
                        <CustomButton
                          title={'Remove'}
                          press={() => (handleRemoveThumbnail())}
                          backgroundColor={'white'}
                          textColor={'#101010'}
                          borderStyle={'1px solid #E3E8EE'}
                          marginLeft={width > 375 ? 5 : 0}
                        />
                      </span>
                    }
                    <input
                      type="file"
                      id={"new-upload-file"}
                      ref={fileInputRef}
                      style={{ display: 'none' }}
                      accept="image/png, image/jpeg"
                      onChange={(e) => onChangeFile(e.target.files[0])}
                    />
                    <div className="setting-desc mt-2">JPG or PNG, 1MB Max.</div>
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <UploadProductImagesNew multiple={true} images={true} values={values?.product_images_details} setFormValues={setFormValues} title={"Product Images"} subtitle={"Click to add product images."} error={error} setNotification={setNotification} />
                  {error && <FormHelperText sx={{ color: "red" }}>{error && Helpers?.getCustomErrorMessageByPrefix(error, "product_images_details.", "The product images details's image must be a valid PNG or JPEG image")}</FormHelperText>}

                </Grid>
                <Grid item xs={12} sm={12}>
                  <FormEditors
                    title={'Overview'}
                    value={values?.product_overview || ''}
                    setValue={(e) => {
                      setFormValues((prevValues) => ({
                        ...prevValues,
                        product_overview: e
                      }))
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <FormEditors
                    title={'Description'}
                    value={values?.product_descriptions || ''}
                    setValue={(e) => {
                      setFormValues((prevValues) => ({
                        ...prevValues,
                        product_descriptions: e
                      }))
                    }}
                  />
                </Grid>
              </Grid>
            </CardBody>
          </Card>
        </Grid>
        <Grid item sm={12} lg={4}>
          <Card className="p-3 px-2">
            <CardBody>
              <div className="setting-header">SETTINGS</div>
              <Divider className="my-2 mb-4" />
              <FormLabel style={{ fontFamily: 'Manrope-Bold', fontSize: 14, paddingBottom: "5px" }}>Product Type</FormLabel>
              {
                type === "Add" ?
                  <Label.CustomLabel label={addType && addType === "simple" ? "Simple Product" : "Configurable Product"} color={addType && addType === "simple" ? "#34c759" : "#2563EB"} backgroundColor={addType === "simple" ? "#e2f8e7" : "#DBEAFE"} />
                  :
                  <Label.CustomLabel label={addType && Helpers?.capitalize(addType) + " Product"} color={addType && addType === "Simple" ? "#34c759" : "#2563EB"} backgroundColor={addType && addType === "Simple" ? "#e2f8e7" : "#DBEAFE"} />
              }
              {
                type === 'Edit' &&
                <div className="mt-4">
                  <FormLabel style={{ fontFamily: 'Manrope-Bold', fontSize: 14, paddingBottom: "5px" }}>Creation Status</FormLabel>
                  <Label.ProductStatusLabel label={productDetails?.creation_status} marginLeft={'0px'} />
                </div>
              }

              {
                <div className="mt-4">
                  <RadioButtonGroup
                    title={'Status'}
                    value={values.status}
                    data={data}
                    setValue={(e) => setFormValues((prevValues) => ({
                      ...prevValues,
                      status: e,
                    }))}
                    required="true"
                    name="status"
                  />
                  {error && <FormHelperText sx={{ color: "red" }}>{error.status || ""}</FormHelperText>}
                </div>
              }


              <div className="mt-3">
                <CheckBoxGroup title="Platform availability" data={platformData} setCheckBoxValue={setPlatformData} row={true} setValue={setFormValues} values={values.platform_availability}
                  onChange={(e) => (
                    e.target.value === "is_ariba_product" && 
                    setFormValues((prevValues) => ({
                      ...prevValues,
                      is_ariba_product: e.target.checked ? 1 : 0,
                      contracts: !is_student_portal ? [] : prevValues?.contracts,
                    })),
                    e.target.value === "is_aspeed_product" &&
                    setFormValues((prevValues) => ({
                      ...prevValues,
                      is_aspeed_product: e.target.checked ? 1 : 0,
                    }))

                  )
                  }
                />
                {error && <FormHelperText sx={{ color: "red" }}>{error && (error?.is_ariba_product || error?.is_ariba_product) && "The platform availability field is required."}</FormHelperText>}
              </div>
              {
                (is_student_portal || values?.is_ariba_product === 1) ?
                  <div className="mt-3">

                    <CustomSelectMultiple
                      title={`Contract ${!is_student_portal ? "(for Ariba)" : ""}`}
                      values={values?.contracts || []}
                      onChange={(e) => setFormValues((prevValues) => ({
                        ...prevValues,
                        contracts: e
                      }))}
                      parentName={"parentName"}
                      valueName={"id"}
                      labelName={"code"}
                      placeholder={'Select one or more'}
                      data={contractsListing?.length > 0 ? contractsListing?.flatMap(item => item.contracts.map(contract => ({ ...contract, parentName: item.name }))) : []}
                      error={error && error?.contracts && "The contracts field is required when platform availability includes Ariba."}
                    />
                  </div>
                  : ""
              }

              <div className="mt-3">
                <RadioButtonGroup
                  flexDirection="column"
                  title={'Visibility'}
                  value={values.visibility}
                  data={visibilityData}
                  setValue={(e) => setFormValues((prevValues) => ({
                    ...prevValues,
                    visibility: e,
                  }))}
                  required="true"
                  name="visibility"
                />
                {error && <FormHelperText sx={{ color: "red" }}>{error.visibility || ""}</FormHelperText>}
              </div>

            </CardBody>
          </Card>
          {productDetails?.product_type !== "variant" && <Card className="p-3 px-2">
            <CardBody>
              <div className="setting-header">SPECIFICATION</div>
              <Divider className="my-2 mb-4" />
              <Grid item xs={12} pb={2} >
                <CustomSelect
                  title={'Manufacturer'}
                  values={values?.manufacturer_id || '-1'}
                  valueName={"id"}
                  labelName={"name"}
                  placeholder={"All"}
                  onChange={(e) => setFormValues((prevValues) => ({
                    ...prevValues,
                    manufacturer_id: e
                  }))}
                  error={error?.manufacturer_id || ""}
                  data={manufactureListing}
                />
              </Grid>
              <Grid item xs={12} pb={2}>
                <CustomSelectMultiple
                  title="Categories"
                  values={values?.product_categories || []}
                  onChange={(e) => (setFormValues((prevValues) => ({
                    ...prevValues,
                    product_categories: e
                  })),

                    handleCatChange(e)
                  )}
                  error={error?.product_categories || ""}
                  valueName={"id"}
                  labelName={"slug"}
                  placeholder={'Select one or more'}
                  data={categoryListing}
                />
              </Grid>
              <Grid item xs={12} pb={2}>
                <CustomSelect
                  title={'Model'}
                  values={values?.model_id}
                  valueName={"id"}
                  labelName={"name"}
                  placeholder={"All"}
                  onChange={(e) => setFormValues((prevValues) => ({
                    ...prevValues,
                    model_id: e
                  }))}
                  error={error?.model_id || ""}
                  data={modelListing}
                />
              </Grid>
            </CardBody>
          </Card>}
        </Grid>

      </Grid >
    )
  }

  const setPositivePress = (type) => {
    if (type === "rejected") {
      handleSubmit(type, "rejected", true)
    } else if (type === "approved") {
      handleSubmit(type, "approved", true)
    }
  }
  return (
    <React.Fragment>
      {
        windowWidth <= 425 &&
        <div className="mobile-button-container">
          {
            type === "Add" ?
              < CustomButton
                title={'Save'}
                press={() => handleSubmit(type)}
                height={40}
                backgroundColor={'#101010'}
                textColor={'white'}
                width={"100%"}
              />
              :
              editable &&
                type === "Edit" && productDetails?.status == 0 ?
                < CustomButton
                  title={'Save Changes'}
                  press={() => handleSubmit(type)}
                  height={40}
                  backgroundColor={'#101010'}
                  textColor={'white'}
                  width={"100%"}
                />
                :
                (approveable && productDetails?.creation_status === "pending_approval" ?
                  <>{
                    <Stack direction={"row"} gap={3}>
                      <CustomButton
                        title={'Reject'}
                        press={() => setRejectMOdal(true)}
                        height={40}
                        borderStyle={"1px solid #ED1A3D"}
                        backgroundColor={'white'}
                        textColor={'#ED1A3D'}
                        width={"50%"}
                      />
                      <CustomButton
                        title={'Approve'}
                        press={() => setApproveMOdal(true)}
                        height={40}
                        backgroundColor={'#34C759'}
                        textColor={'white'}
                        width={"50%"}
                      />
                    </Stack>
                  }</>
                  :
                  approveable && productDetails?.creation_status === "rejected" ?
                    <CustomButton
                      title={'Approve'}
                      press={() => setApproveMOdal(true)}
                      height={40}
                      backgroundColor={'#34C759'}
                      textColor={'white'}
                      width={"100%"}
                    />
                    :
                    < CustomButton
                      title={'Save Changes'}
                      press={() => handleSubmit(type)}
                      height={40}
                      backgroundColor={'#101010'}
                      textColor={'white'}
                      width={"100%"}
                    />
                )
          }
        </div>
      }
      <div id="page-stickyheader" style={{ width: '-webkit-fill-available' }}>
        <div className="page-content" style={{ paddingBottom: "0px" }}>
          <RejectModal open={rejectModal} setOpen={setRejectMOdal} values={values} setFormValues={setFormValues} setPositivePress={() => setPositivePress("rejected")} />
          <ApproveModal open={approveModal} setOpen={setApproveMOdal} values={values} setFormValues={setFormValues} setPositivePress={() => setPositivePress("approved")} platformData={platformData} setPlatformData={setPlatformData} />
          <Breadcrumbs
            title={title}
            backRoute={"/product-listing"}
            breadcrumbItems={[{ title: "Products", link: "/product-listing" },
            { title: title, link: "#" },
            ]}
          >
            {
              windowWidth > 425 &&
              <>
                {
                  type === "Add" ?
                    < CustomButton
                      title={'Save'}
                      press={() => handleSubmit(type)}
                      height={40}
                      backgroundColor={'#101010'}
                      textColor={'white'}
                    />
                    :
                    editable &&
                      type === "Edit" && productDetails?.status == 0 ?
                      < CustomButton
                        title={'Save Changes'}
                        press={() => handleSubmit(type)}
                        height={40}
                        backgroundColor={'#101010'}
                        textColor={'white'}
                      />
                      :
                      (approveable && productDetails?.creation_status === "pending_approval" ?
                        <>{
                          <Stack direction={"row"} gap={3}>
                            <CustomButton
                              title={'Reject'}
                              press={() => setRejectMOdal(true)}
                              height={40}
                              borderStyle={"1px solid #ED1A3D"}
                              backgroundColor={'white'}
                              textColor={'#ED1A3D'}
                            />
                            <CustomButton
                              title={'Approve'}
                              press={() => setApproveMOdal(true)}
                              height={40}
                              backgroundColor={'#34C759'}
                              textColor={'white'}
                            />
                          </Stack>
                        }</>
                        :
                        approveable && productDetails?.creation_status === "rejected" ?
                          <CustomButton
                            title={'Approve'}
                            press={() => setApproveMOdal(true)}
                            height={40}
                            backgroundColor={'#34C759'}
                            textColor={'white'}
                          />
                          :
                          < CustomButton
                            title={'Save Changes'}
                            press={() => handleSubmit(type)}
                            height={40}
                            backgroundColor={'#101010'}
                            textColor={'white'}
                          />
                      )
                }
              </>
            }

          </Breadcrumbs>
          <div>
            <Tabs value={parseInt(tabValue)}
              textColor="red"
              indicatorColor="secondary"
              scrollButtons={true} variant="scrollable"
              sx={{
                color: "#A0A0A0",
                "&.Mui-selected": {
                  color: '#282828',
                },
              }}
              onChange={(e, val) => handleChangeTab(val)} aria-label="basic tabs example" TabIndicatorProps={{ style: { backgroundColor: 'var(--bs-theme-color)' } }}>
              {
                tabData?.map((x, idx) =>
                  <Tab key={idx} label={<div className="d-flex" >{x?.name}</div>} value={x.id} style={{ color: parseInt(tabValue) === x.id ? '#282828' : '#A0A0A0' }} />
                )
              }
            </Tabs>
          </div>
        </div>
      </div>
      <div className="page-content pt-4" >
        <div className="" style={{ paddingTop: "200px" }}>
          <LoadingDialog open={loading} />
          <Container fluid>
            <Notification notification={notification} setNotification={setNotification} />
            <div id={0} className="observe-div">
              {renderGeneralTab()}
            </div>
            <Grid container>
              {productDetails?.product_type !== "variant" && <Grid item sm={12} lg={8}>
                <div id={1} className="observe-div">
                  <Pricing width={width} values={values} setFormValues={setFormValues} error={error} isDifferentPrice={isDifferentPrice} setIsDifferentPrice={setIsDifferentPrice} />
                </div>
              </Grid>}
              {
                values?.product_type !== "variant" &&
                <Grid item sm={12} lg={8}>
                  <div id={2} className="observe-div">
                    {
                      type === "Add"
                        ?
                        addType === "configurable" ?
                          <ConfigProductSpec values={values} setFormValues={setFormValues} error={error} type={type} setCategoryForTab={setCategoryForTab} categoryForTab={categoryForTab} setNotification={setNotification} configurationDetails={configurationDetails} productListing={filteredProductList}
                            width={width} allowMultipleSelect={allowMultipleSelect} setAllowMultipleSelect={setAllowMultipleSelect}// setConfigurationItemId={setConfigurationItemId}
                          />
                          :
                          <ProductSpec values={values} setFormValues={setFormValues} error={error} type={type} setCategoryForTab={setCategoryForTab} categoryForTab={categoryForTab} configurationDetails={configurationDetails}
                            width={width}// setConfigurationItemId={setConfigurationItemId} 
                          />
                        :
                        addType === "configurable" ?
                          <ConfigProductSpec values={values} setFormValues={setFormValues} error={error} type={type} setCategoryForTab={setCategoryForTab} categoryForTab={categoryForTab} setNotification={setNotification} configurationDetails={configurationDetails}
                            width={width}// setConfigurationItemId={setConfigurationItemId} 
                            productListing={filteredProductList} allowMultipleSelect={allowMultipleSelect} setAllowMultipleSelect={setAllowMultipleSelect} />
                          :
                          <ProductSpec values={values} setFormValues={setFormValues} error={error} type={type} setCategoryForTab={setCategoryForTab} categoryForTab={categoryForTab} configurationDetails={configurationDetails}
                            width={width} // setConfigurationItemId={setConfigurationItemId} 
                          />

                    }
                  </div>
                </Grid>
              }

              {addType === "configurable" ?
                values?.product_type !== "variant" ?
                  <Grid item sm={12} lg={8}>
                    <div id={3} className="observe-div">
                      <Services width={width} values={values} setFormValues={setFormValues} error={error} setNotification={setNotification} extractNumber={extractNumber} />
                    </div>
                  </Grid> :
                  "" : ""
              }

              {
                <Grid item sm={12} lg={8} style={{ width: " 100%" }}>
                  <div id={8} className="observe-div">
                    <Attachments values={values} setFormValues={setFormValues} error={error} />
                  </div>
                </Grid>
              }

              {/* gift */}
              {values?.product_type !== "variant" &&
                <Grid item sm={12} lg={8} style={{ width: " 100%" }}>
                  <div id={4} className="observe-div">
                    <Gift values={values} setFormValues={setFormValues} error={error} productListing={productListingForGift} />
                  </div>
                </Grid>}

              {/* accessoried */}
              {values?.product_type !== "variant" &&
                <Grid item sm={12} lg={8}>
                  <div id={5} className="observe-div">
                    <Accessories values={values} setFormValues={setFormValues} error={error} addType={addType} setNotification={setNotification} categoryListing={categoryListing} />
                  </div>
                </Grid>}

              {/* shipping */}
              {productDetails?.product_type !== "variant" && <Grid item sm={12} lg={8}>
                <div id={6} className="observe-div">
                  <Shipping values={values} setFormValues={setFormValues} error={error} />
                </div>
              </Grid>}

              {/* seo */}
              {productDetails?.product_type !== "variant" && <Grid item sm={12} lg={8}>
                <div id={7} className="observe-div">
                  <SEO values={values} setFormValues={setFormValues} error={error} />
                </div>
              </Grid>}

            </Grid>

          </Container>

        </div>
      </div>
    </React.Fragment >
  );
};

function mapStateToProps({ Product, Configuration, General, Login }) {
  return {
    productds: Product,

    productDetails: Product.productDetails?.data,
    productMessage: Product.productDetails,
    addProduct: Product.addProduct,
    editProduct: Product.updateProduct,
    configurationDetails: Configuration.configurationDetails.data,
    productListingForGift: General.gift_products,
    is_student_portal: General.is_student_portal,
    // productListingForAccesories: Product.productListingForAccesories,
    contractsListing: General.school_contracts,
    categoryListing: General.categories,
    products: General.products,
    manufactureListing: General.manufacturers,
    modelListing: General.models,
    attachment: General.attachment,
    thumbnailAttachment: General.thumbnailAttachment,
    errors: Product.error,
    preAddData: Product.preAddData,
    userPermission: Login.permissionArry,

  };
}


export default connect(mapStateToProps)(AddSimpleProduct);
